export const environment = {
  production: false,
  api_url: 'https://paxi-parcel-web-service-kg34jdjneq-ew.a.run.app/parcel/fetchparceltrackingfull',
};
